export default __webpack_public_path__ + "static/media/nula.6b945627.png";